import { render, staticRenderFns } from "./settings-icon.vue?vue&type=template&id=5378a354&scoped=true"
import script from "./settings-icon.vue?vue&type=script&lang=js"
export * from "./settings-icon.vue?vue&type=script&lang=js"
import style0 from "./settings-icon.vue?vue&type=style&index=0&id=5378a354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378a354",
  null
  
)

export default component.exports